import "alpinejs";
import axios from "axios";
import { dl } from "../../src/js/core/app";

window.donationBaseUrl = window.location.hostname.toLowerCase() === 'justdiggit.lamalama.dev'
  ? "https://donations-justdiggit.lamalama.dev/api"
  : window.location.hostname.toLowerCase() === 'justdiggit.test'
    ? "http://donations.justdiggit.test/api"
    : "https://donations.justdiggit.org/api";

let langCode = getLangCode;

async function fetchPaymentMethods() {
  try {
    // Get the language from the HTML tag
    const htmlLang = document.documentElement.lang || 'en';
    const locale = htmlLang.replace('-', '_');

    // Build the URL
    let url = `${window.donationBaseUrl}/mollie/payment-options?locale=${locale}&interval=${this.donateForm.interval}`;
    if (this.currency) {
      url += `&currency=${this.currency}`;
    }

    // Fetch the payment methods
    const response = await axios.get(url);
    const tempPayMethods = [];

    for (const m in response.data.paymentMethods) {
      tempPayMethods.push(response.data.paymentMethods[m]);
    }

    this.paymentMethods = tempPayMethods;

    // If the currency is not set, set it to the currency from the response
    if (response.data.currency && !this.currency) {
      // Set currency for the widget
      this.currency = response.data.currency;

      // Set currency for the donation
      this.donateForm.currency = this.currency;
    }
  } catch (err) {
    console.error(err);
  }
}

function donateNow() {
  if (!this.validateDonation()) {
    return false;
  }

  const url = `${window.donationBaseUrl}/mollie/pay`;

  // Get donation reference from URL if present
  const urlParams = new URLSearchParams(window.location.search);
  const donationRef = urlParams.get('donationref');
  if (donationRef) {
    this.donateForm.donation_ref = donationRef;
  }

  grecaptcha.ready(() => {
    grecaptcha
      .execute("6LfbCYMgAAAAAJL-CA1-8dlf90XYnv6zA7jAKzD5", { action: "submit" })
      .then((token) => {
        this.donateForm.token = token;
        axios
          .post(url, this.donateForm)
          .then((response) => {
            window.location.href = response.data.redirect;
          })
          .catch((error) => {
            console.error(error);
            window.alert(
              "Something went wrong processing your donation. Please try again or contact us"
            );
          });
      });
  });
}

function emailIsValid(email) {
  return /\S+@\S+\.\S+/.test(email);
}

function realtimeValidation() {
  if (this.validationStarted) {
    this.validateDonation(true);
  }
}

function validateDonation(realtime = false) {
  this.isInvalid = {
    amount: false,
    currency: false,
    amountValid: false,
    interval: false,
    firstName: false,
    lastName: false,
    email: false,
    company_phone_number: false,
    company_name: false,
    company_chamber_of_commerce_number: false,
    company_address: false,
    company_zipcode: false,
    company_place: false,
    method: false,
    issuer: false,
    optIn: false,
  };

  this.validationStarted = true;

  let isValid = true;
  let tab = undefined;

  if (!this.donateForm.method) {
    tab = "paymentMethod";
    this.isInvalid.method = "Please provide a payment method"; // Message comes from ACF
    isValid = false;
  }

  if (this.optInText()) {
    if (!this.donateForm.optIn) {
      tab = "paymentMethod";
      this.isInvalid.optIn = "Please give us permission"; // Message comes from ACF
      isValid = false;
    }
  }

  if (!this.donateForm.firstName) {
    tab = "personalDetails";
    this.isInvalid.firstName = "Please provide your first name"; // Message comes from ACF
    isValid = false;
  }

  if (!this.donateForm.lastName) {
    tab = "personalDetails";
    this.isInvalid.lastName = "Please provide your last name"; // Message comes from ACF
    isValid = false;
  }

  if (!emailIsValid(this.donateForm.email)) {
    tab = "personalDetails";
    this.isInvalid.email = "Please provide a valid e-mailaddress"; // Message comes from ACF
    isValid = false;
  }

  if (!this.donateForm.email) {
    tab = "personalDetails";
    this.isInvalid.email = "Please provide your e-mailaddress"; // Message comes from ACF
    isValid = false;
  }

  if (this.donateForm.donation_type === "business") {
    if (!this.donateForm.company_phone_number) {
      tab = "personalDetails";
      this.isInvalid.company_phone_number = "Please provide your phone number"; // Message comes from ACF
      isValid = false;
    }

    if (!this.donateForm.company_name) {
      tab = "personalDetails";
      this.isInvalid.company_name = "Please provide your company name"; // Message comes from ACF
      isValid = false;
    }

    if (!this.donateForm.company_chamber_of_commerce_number) {
      tab = "personalDetails";
      this.isInvalid.company_chamber_of_commerce_number = "Please provide your the COC number"; // Message comes from ACF
      isValid = false;
    }

    if (!this.donateForm.company_address) {
      tab = "personalDetails";
      this.isInvalid.company_address = "Please provide your address"; // Message comes from ACF
      isValid = false;
    }

    if (!this.donateForm.company_zipcode) {
      tab = "personalDetails";
      this.isInvalid.company_zipcode = "Please provide your postal code"; // Message comes from ACF
      isValid = false;
    }

    if (!this.donateForm.company_place) {
      tab = "personalDetails";
      this.isInvalid.company_place = "Please provide your city"; // Message comes from ACF
      isValid = false;
    }
  }

  if (!this.donateForm.amount) {
    tab = "amount";
    this.isInvalid.amount = "Please provide the amount you want to donate"; // Message comes from ACF
    isValid = false;
  }

  if (this.donateForm.amount) {
    // If an amount is set. Check if the notation is valid
    const amountRegex = /^\d{0,20}(?:[.]\d{1,2})?$/g;
    if (!this.donateForm.amount.match(amountRegex)) {
      tab = "amount";
      this.isInvalid.amountValid = "Please provide a valid amount: e.g. 12.50"; // Message comes from ACF
      isValid = false;
    }
  }

  if (!this.donateForm.interval) {
    tab = "amount";
    this.isInvalid.interval = "Please select the frequency you would like to donate"; // Message comes from ACF
    isValid = false;
  }

  if (tab && !realtime) {
    this.tab = tab;
  }

  return isValid;
}

window.donateInit = function () {
  this.$watch("currency", (value) => {
    this.donateForm.currency = value;
    this.fetchPaymentMethods();
  });

  this.$watch("donateForm.interval", (value) => {
    this.fetchPaymentMethods();
  });
};

window.donateState = () => {
  return {
    tab: "amount",
    paymentMethods: [],
    currency: null,
    customAmount: false,
    validationStarted: false,
    donateForm: {
      currency: undefined,
      amount: undefined,
      interval: undefined,
      firstName: undefined,
      lastName: undefined,
      email: undefined,
      donation_type: document.querySelector(".js-input-donation-type")
        ? document.querySelector(".js-input-donation-type").value
        : null,
      company_phone_number: undefined,
      company_name: undefined,
      company_chamber_of_commerce_number: undefined,
      company_address: undefined,
      company_zipcode: undefined,
      company_place: undefined,
      method: undefined,
      issuer: undefined,
      paymentDomain: "justdiggit.org",
      optIn: false,
      acceptsMarketing: true,
      language: document.querySelector(".js-donation-lang")
        ? document.querySelector(".js-donation-lang").value
        : null,
      token: false,
    },
    isInvalid: {
      amount: undefined,
      interval: undefined,
      firstName: undefined,
      lastName: undefined,
      email: undefined,
      company_phone_number: undefined,
      company_name: undefined,
      company_chamber_of_commerce_number: undefined,
      company_address: undefined,
      company_zipcode: undefined,
      company_place: undefined,
      method: undefined,
    },
    fetchPaymentMethods,
    donateNow,
    validateDonation,
    realtimeValidation,
    showValidation(field, message) {
      if (!this.isInvalid[field]) {
        return false;
      }

      if (message) {
        return message;
      }

      return this.isInvalid[field];
    },
    optInText(line = "I allow Justdiggit to {frequency} withdraw {currency} {amount} from my bankaccount.") {
      if (!this.donateForm.interval) {
        return "";
      }
      if (this.donateForm.interval === "single") {
        return "";
      }
      if (!this.donateForm.amount) {
        return "";
      }
      let frequency = "";

      switch (this.donateForm.interval) {
        case "1_weeks":
          if (langCode == "nl") {
            frequency = "wekelijks";
          } else if (langCode == "fr") {
            frequency = "hebdomadaire";
          } else if (langCode == "de") {
            frequency = "wöchentlich";
          } else {
            frequency = "weekly";
          }
          break;
        case "1_months":
          if (langCode == "nl") {
            frequency = "maandelijks";
          } else if (langCode == "fr") {
            frequency = "mensuel";
          } else if (langCode == "de") {
            frequency = "monatlich";
          } else if (langCode == "sw") {
            frequency = "mwezi";
          } else {
            frequency = "monthly";
          }
          break;
        case "12_months":
          if (langCode == "nl") {
            frequency = "jaarlijks";
          } else if (langCode == "fr") {
            frequency = "annuel";
          } else if (langCode == "de") {
            frequency = "jährlich";
          } else if (langCode == "sw") {
            frequency = "mwaka";
          } else {
            frequency = "yearly";
          }
          break;
        case "2_weeks":
          if (langCode == "nl") {
            frequency = "tweewekelijks";
          } else if (langCode == "fr") {
            frequency = "bihebdomadaire";
          } else if (langCode == "de") {
            frequency = "zweiwöchentlich";
          } else {
            frequency = "bi-weekly";
          }
          break;
        case "3_months":
          if (langCode == "nl") {
            frequency = "per kwartaal";
          } else if (langCode == "fr") {
            frequency = "trimestriel";
          } else if (langCode == "de") {
            frequency = "vierteljährlich";
          } else {
            frequency = "quaterly";
          }
          break;
        case "6_months":
          if (langCode == "nl") {
            frequency = "twee keer per jaar";
          } else if (langCode == "fr") {
            frequency = "deux fois par an";
          } else if (langCode == "de") {
            frequency = "zweimal im Jahr";
          } else {
            frequency = "twice per year";
          }
          break;
      }

      return line
        .replace("{frequency}", frequency)
        .replace("{currency}", this.getCurrencySymbol(this.donateForm.currency))
        .replace("{amount}", this.donateForm.amount);
    },
    getCurrencySymbol(currency) {
      switch (currency) {
        case "EUR":
          return "€";
        case "USD":
          return "$";
        case "GBP":
          return "£";
        default:
          return currency;
      }
    }
  };
};

export class DonateDL {
  constructor() {
    setTimeout(() => {
      this.successPage();
    }, 300);

    if (!document.querySelector(".donate__section__footer")) {
      return false;
    }
    this.usps = document.querySelector(".js-donate-usps");
    this.privacy = document.querySelector(".js-donate-privacy");
    this.price = "";
    this.variant = "";
    this.amountHeader = document.querySelector("#js-donate-amount-header");

    setTimeout(() => {
      this.defaultPreSelect();
    }, 250);

    setTimeout(() => {
      this.step1();
      this.step2();
      this.step3();
    }, 300);
  }

  defaultPreSelect() {
    document.querySelector(".js-period-fields:nth-of-type(2)").click();
    document.querySelector(".js-amount-fields:nth-of-type(2)").click();
  }

  showPrivacy() {
    if (this.usps && this.privacy) {
      this.usps.classList.add("hidden");
      this.privacy.classList.remove("hidden");
    }
  }

  hidePrivacy() {
    if (this.usps && this.privacy) {
      this.usps.classList.remove("hidden");
      this.privacy.classList.add("hidden");
    }
  }

  info() {
    this.amountContainer = document.querySelector(".amount-container");
    this.donateType = document.querySelector(".js-donate-type").getAttribute("data-donate-type");
    let otherAmount = document.querySelector(".amount__option__input");
  }

  getPrice() {
    let otherAmount = document.querySelector(".amount__option__input");
    if (document.querySelector(".amount__option.wider.active")) {
      this.price = otherAmount.value;
    } else if (document.querySelector(".amount__option.active")) {
      this.price = document.querySelector(".amount__option.active").getAttribute("data-amount");
    }

    this.variant = document.querySelector(".interval__option.active").getAttribute("data-interval");
    this.variantNormalized = document
      .querySelector(".interval__option.active")
      .getAttribute("data-interval");

    if (this.variantNormalized === "single") {
      this.variantNormalized = "once";
    } else if (this.variantNormalized === "1_months") {
      this.variantNormalized = "monthly";
    } else if (this.variantNormalized === "12_months") {
      this.variantNormalized = "yearly";
    }
  }

  removeHeaderPointerEvents(number) {
    document
      .querySelector(`.donate__section__heading li:nth-of-type(${number})`)
      .classList.remove("pointer-events-none");
  }

  checkAmount() {
    this.fields = document.querySelectorAll(".js-period-fields");
    this.amountFields = document.querySelectorAll(".js-amount-fields");
    this.aaa = false;

    this.fields.forEach((field) => {
      field.addEventListener("click", () => {
        this.aaa = true;
        if (this.aaa == true && this.bbb == true) {
          document.querySelector(".js-go-step-2").classList.remove("pointer-events-none");
        }
      });
    });

    this.amountFields.forEach((field) => {
      field.addEventListener("click", () => {
        this.bbb = true;
        if (this.aaa == true && this.bbb == true) {
          document.querySelector(".js-go-step-2").classList.remove("pointer-events-none");
        }
      });
    });
  }

  step1() {
    this.goStep2 = document.querySelector(".js-go-step-2");
    if (!this.goStep2) {
      return false;
    }
    this.checkAmount();

    this.info();

    this.goStep2.addEventListener("click", (e) => {
      this.getPrice();
      this.showPrivacy();

      let object = {
        name: `${this.donateType} donation ${this.variantNormalized}`,
        // id: '1234',
        price: this.price,
        variant: this.variantNormalized,
        category: `${this.donateType}`,
      };
      this.removeHeaderPointerEvents(1);
      this.removeHeaderPointerEvents(2);
      dl.checkout("1. make a donation", object);
    });

    this.amountHeader.addEventListener("click", () => {
      this.hidePrivacy();
    });
  }

  step2() {
    this.goStep3 = document.querySelector(".js-go-step-3");
    if (!this.goStep3) {
      return false;
    }

    this.info();

    this.goStep3.addEventListener("click", () => {
      let email = document.querySelector(".js-input-email").value;
      this.getPrice();

      let object = {
        name: `${this.donateType} donation ${this.variantNormalized}`,
        // id: '1234',
        price: this.price,
        variant: this.variantNormalized,
        category: `${this.donateType}`,
      };

      this.removeHeaderPointerEvents(3);
      dl.checkout("2. your details", object, email);
    });
  }

  step3() {
    this.goStepDone = document.querySelector(".js-go-step-done");
    if (!this.goStepDone) {
      return false;
    }

    this.info();

    this.goStepDone.addEventListener("click", () => {
      let email = document.querySelector(".js-input-email").value;
      let paymentMethod = document.querySelector(".payment-method.active .payment-method__title")
        ? document.querySelector(".payment-method.active .payment-method__title").innerHTML
        : false;
      this.getPrice();

      let object = {
        name: `${this.donateType} donation ${this.variantNormalized}`,
        // id: '1234',
        price: parseFloat(this.price),
        variant: this.variantNormalized,
        category: `${this.donateType}`,
      };

      sessionStorage.setItem("donationInfo", JSON.stringify(object));
      dl.checkout("3. payment method", object, email, paymentMethod);
    });
  }

  successPage() {
    this.successPage = document.querySelector(".js-donate-success");
    if (!this.successPage) {
      return false;
    }
    this.lang = this.successPage.getAttribute("data-lang");
    let purchaseID;
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const pid = urlParams.get("pid");
    const token = urlParams.get("token");
    axios
      .post(`${window.donationBaseUrl}/validate-token`, {
        pid: pid,
        token: token,
      })
      .then((response) => {
        purchaseID = response.data.data;
        if ("donationInfo" in sessionStorage) {
          let object = JSON.parse(sessionStorage.donationInfo);
          object.price = parseFloat(object.price);
          console.log('Send to datalayer', object)
          dl.purchase(object, this.lang, purchaseID);
          sessionStorage.removeItem("donationInfo");
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  }
}
